import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock, Users, Globe, Search, X } from 'lucide-react';
import { Input } from 'components/ui/input';
import { useTheme } from 'components/core/theme-provider';

export const SharingTab = () => {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const [visibility, setVisibility] = React.useState('private');

    const visibilityOptions = [
        { id: 'private', title: t('PRIVATE'), description: t('ONLY_YOU_CAN_ACCESS_THIS_ASSISTANT'), icon: Lock },
        { id: 'specific', title: t('SPECIFIC_USERS_GROUPS'), description: t('SHARE_WITH_SELECTED_USERS_OR_GROUPS'), icon: Users },
        { id: 'org', title: t('ORGANIZATION'), description: t('ALL_ORGANIZATION_MEMBERS_CAN_ACCESS'), icon: Globe },
    ];

    const members = [
        { name: 'Engineering Team', info: '22 Members', type: 'group' },
        { name: 'Jane Smith', info: 'jane.smith@company.com', type: 'user' },
    ];

    return (
        <div className="space-y-6 animate-in fade-in slide-in-from-bottom-2 duration-300">
            <div className="space-y-4">
                <h3 className={`${theme === 'dark' ? "text-typography-white" : "text-black-500"} text-sm font-medium leading-[22px] font-inter`}>{t('SHARE_ASSISTANT_WITH') || 'Share Assistant With'}</h3>
                <div className="space-y-2">
                    {visibilityOptions.map((opt) => (
                        <button
                            disabled={opt.id !== 'private'}
                            key={opt.id}
                            onClick={() => setVisibility(opt.id)}
                            className={`w-full flex items-center justify-between p-4 rounded-lg border ${theme === 'dark' ? 'border-black-800 bg-black-300' : 'border-black-100 bg-typography-white'} transition-all text-left ${visibility === opt.id && theme === 'dark' ? 'bg-[#AC95784D]' : ''} disabled:opacity-50 disabled:cursor-not-allowed`}
                        >
                            <div className="flex items-center gap-4">
                                {/* <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${visibility === opt.id ? 'bg-[#b49b78]/20' : 'bg-white/10'}`}> */}
                                <opt.icon className={`w-4 h-4 ${theme === 'dark' ? 'text-typography-white' : 'text-typography-grey-1-secondary'} ${visibility === opt.id ? 'text-[#b49b78]' : 'text-gray-400'}`} />
                                {/* </div> */}
                                <div className="flex flex-col">
                                    <span className={`${theme === 'dark' ? 'text-typography-white' : 'text-typography-black-primary'} text-sm font-medium leading-[22px] break-words`}>{opt.title}</span>
                                    <span className={`${theme === 'dark' ? 'text-typography-grey-2-secondary-stroke' : 'text-typography-grey-1-secondary'} text-xs font-normal leading-[18px] break-words`}>{opt.description}</span>
                                </div>
                            </div>
                            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${visibility === opt.id ? 'border-[#b49b78]' : 'border-gray-600'}`}>
                                {visibility === opt.id && <div className="w-2.5 h-2.5 rounded-full bg-[#b49b78]" />}
                            </div>
                        </button>
                    ))}
                </div>
            </div>

            {visibility === 'specific' && (
                <div className="flex flex-col gap-3 pt-2">
                    <h3 className={`${theme === 'dark' ? "text-typography-white" : "text-typography-black-primary"} text-sm font-medium leading-[22px] break-words`}>{t('ADD_USERS_OR_GROUPS') || 'Add Users or Groups'}</h3>
                    <div className="flex gap-3">
                        <div className={`flex flex-1 pl-4 border ${theme === 'dark' ? "bg-black-200 border-black-500" : "bg-[#FFFFFF] border-[#AC9578]"} rounded-full flex items-center gap-2`}>
                            <Search className={`w-4 h-4 ${theme === 'dark' ? "text-[#816C51]" : "text-[#816C51]"} `} />
                            <Input
                                placeholder={t('SEARCH_MEDIA_BY_NAME') || 'Search media by name...'}
                                className={`px-0 py-0 shadow-none border-none rounded-full outline-none focus-visible:ring-0 focus-visible:outline-none focus-visible:border-none ${theme === 'dark' ? "bg-black-200 text-typography-grey-2-secondary-stroke" : "bg-[#FFFFFF] text-typography-grey-2-secondary"}`}
                            />
                        </div>
                        <button className={`${theme === 'dark' ? "bg-[#816C51] text-typography-white" : "bg-[#816C51] text-typography-white"} text-sm font-semibold leading-6 px-3 py-1.5 rounded-md flex items-center justify-center gap-2 inline-flex`}>
                            {t('ADD') || 'Add'}
                        </button>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4">
                        {members.map((member, idx) => (
                            <div key={idx} className={`flex items-center justify-between p-3 rounded-lg ${theme === 'dark' ? "bg-[#AC95784D] border-[#BCBCBE] border" : "bg-[#FFF0D040] border-[#AC9578] border"}`}>
                                <div className="flex flex-col">
                                    <span className={`${theme === 'dark' ? "text-typography-white" : "text-typography-black-primary"} text-sm font-normal leading-6 font-inter`}>{member.name}</span>
                                    <span className={`${theme === 'dark' ? "text-typography-grey-2-secondary-stroke" : "text-typography-grey-1-secondary"} text-xs font-normal leading-4 font-inter`}>{member.info}</span>
                                </div>
                                <button className={`${theme === 'dark' ? "text-neutral-700" : "text-[#959595]"} transition-colors`}>
                                    <X className="w-4 h-4" />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
